var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.toCSV()),expression:"toCSV()",arg:"copy"}],attrs:{"outlined":"","color":"orange"}},[_vm._v(" "+_vm._s(_vm.$t("misc.copy"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }